import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { BannerVariant } from '../../models/component.model';
import { ContentWrapper } from '../collections/ContentWrapper';
import { ImageContentDisplay } from '../images/ImageContentDisplay';
import { ContentHtml } from '../sections/ContentHtml';
import { LinkContentDisplay } from '../sections/LinkContentDisplay';

interface Props {
    item: BannerVariant;
    before?: React.ReactNode;
    contentClassName?: string;
}

export const BannerVariantDisplay = ({
    item,
    before,
    contentClassName,
}: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);

    return (
        <>
            {sections.map((section, index) => {
                const id = createElementId(section.id);

                return (
                    <ContentWrapper
                        id={id}
                        key={id}
                        contentClassName={`banner-variant-display ${contentClassName || ''}`}
                    >
                        <div className="p-5">
                            {index === 0 && <>{before}</>}
                            <div id={id} className="d-flex position-relative banner-section">
                                <div className="position-absolute w-100 h-100 tl-0 z-1 banner-variant-curtain"></div>
                                {section.image && (
                                    <div className="position-absolute w-100 h-100 tl-0 z-0">
                                        <ImageContentDisplay image={section.image} />
                                    </div>
                                )}
                                <div className="align-self-center z-2 p-5 banner-section-content">
                                    {section.header && (
                                        <h2 className="display-5 mb-3 content-header">
                                            {section.header}
                                        </h2>
                                    )}
                                    {section.body && <ContentHtml source={section.body} />}
                                    {section.link && (
                                        <div>
                                            <LinkContentDisplay link={section.link} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </ContentWrapper>
                );
            })}
        </>
    );
};
